import React from "react";
import { StandarDataTable } from "@ioip/core/lib/components";
import { GetPermissionLevelString, IPermission, PermissionLevel } from "../studio-types";
import { GetPermissionAssignmentString, PermissionAssignmentType } from "../studio-types/PermissionAssignmentType";
import { XPermission } from "./XPermission";
import { isNullOrEmpty } from "@ioip/core/lib";

export interface IXPermissionCollectionProps {
    items: IPermission[];
    onChanged: (items: IPermission[]) => void;
    title?: string;
}

export const XPermissionCollection = React.memo((props: IXPermissionCollectionProps): JSX.Element => {

    return <StandarDataTable
        columns={[
            {
                name: 'Assignment type',
                minWidth: 200,
                onRender: x => GetPermissionAssignmentString(x.assignmentType)
            },
            {
                name: 'Permission level',
                minWidth: 200,
                onRender: item => GetPermissionLevelString(item.permissionLevel)
            },
            {
                name: 'Start date',
                minWidth: 150,
                onRender: item => isNullOrEmpty(item.startDate) ? 'N/A' : item.startDate
            },
            {
                name: 'End date',
                minWidth: 150,
                onRender: item => isNullOrEmpty(item.endDate) ? 'N/A' : item.endDate
            },
            {
                name: 'Description',
                minWidth: 150,
                onRender: item => item.description
            }
        ]}
        items={props.items || []}
        panelTitle="Permission"
        tableTitle={props.title}
        onItemsChanged={items => props.onChanged(items)}
        rowKey={x => x.id}
        onRenderItemPanel={(item, errors, setValues) => <XPermission
            errors={errors}
            item={item}
            setValues={setValues}
        />}
    />

});